<template>
    <div
        class="flex items-center justify-center rounded-0.75 transition-all"
        :class="[
            wrapClass,
            borderClass,
            height,
            width
        ]"
        @click="onChangeCheck"
    >
        <CheckerIcon
            v-if="checked"
            class="transition-opacity"
            :class="disabled ? 'text-white dark:text-gray-200' : 'text-white'"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue'

import CheckerIcon from '@/components/icons/theme/CheckerIcon.vue'

const props = defineProps({
    checked: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    hidden: {
        type: Boolean,
        default: false,
    },
    height: {
        type: String,
        default: 'h-4',
    },
    width: {
        type: String,
        default: 'w-4',
    },
    borderClass: {
        type: String,
        default: 'border',
    },
})

const emits = defineEmits(['update:checked', 'onChangeCheck'])

const isCheck = computed({
    get() {
        return props.checked
    },
    set(data) {
        emits('update:checked', data)
        emits('onChangeCheck', data)
    },
})

function onChangeCheck() {
    if (props.disabled || props.loading) {
        return
    }

    isCheck.value = !isCheck.value
}

const wrapClass = computed(() => {
    if (props.disabled) {
        return 'border-gray-200 bg-gray-200 dark:border-gray-370 dark:bg-gray-370 opacity-50 dark:opacity-30'
    }

    const cursor = props.loading ? 'cursor-wait' : ' cursor-pointer'

    const classes = [cursor]

    if (props.hidden && !props.checked) {
        classes.push('min-mb:opacity-0 min-mb:group-hover/row:opacity-100')
    }

    if (props.checked) {
        classes.push('border-purple bg-purple')
    } else {
        classes.push('border-gray-200')
    }

    return classes.join(' ')
})
</script>
